import AjaxLoader from '../ajax-loader/ajax-loader';

const BS_CLASS_NAME_POSITION_ABSOLUTE = 'position-absolute';
const BS_CLASS_NAME_POSITION_RELATIVE = 'position-relative';
const BS_CLASS_NAME_WIDTH_FULL = 'w-100';
const BS_CLASS_NAME_TARGET_LOADER = 'js-btn-loader';
const BS_CLASS_NAME_TARGET_CONTENT = 'js-btn-text';
const BS_CLASS_NAME_ACTIVE = '-active';

const CLASS_NAME_OPACITY_0 = 'opacity-0';

function setupLoadingSpinner(submit) {
    const loader = new AjaxLoader(null, {
        light: true,
        size: 'xs'
    });

    const $submit = $(submit);

    const $container = $('<div></div>').addClass(BS_CLASS_NAME_POSITION_RELATIVE).attr('role', 'text');
    const $loader = $('<div></div>').addClass([BS_CLASS_NAME_POSITION_ABSOLUTE, BS_CLASS_NAME_WIDTH_FULL, BS_CLASS_NAME_TARGET_LOADER]).html(loader.render());
    const $content = $('<div></div>').addClass([BS_CLASS_NAME_TARGET_CONTENT]).html($submit.html());

    $container.append([ $loader, $content ]);
    $submit.html($container);
}

function startLoadingSpinner(submit){
    const $submit = $(submit);
    $submit.prop('disabled', true);
    $submit.find('.' + BS_CLASS_NAME_TARGET_CONTENT).addClass(CLASS_NAME_OPACITY_0);
    $submit.find('.ajax-loader__main').addClass(BS_CLASS_NAME_ACTIVE);
}

function stopLoadingSpinner(submit){
    const $submit = $(submit);
    $submit.prop('disabled', false);
    $submit.find('.' + BS_CLASS_NAME_TARGET_CONTENT).removeClass(CLASS_NAME_OPACITY_0);
    $submit.find('.ajax-loader__main').removeClass(BS_CLASS_NAME_ACTIVE);
}

export {setupLoadingSpinner, startLoadingSpinner, stopLoadingSpinner}